// extracted by mini-css-extract-plugin
module.exports = {"highlight":"CalendarControlPanel_highlight__1giVp","disabled":"CalendarControlPanel_disabled__2ZX-i","Spinner":"CalendarControlPanel_Spinner__396JD"};